import React, { useLayoutEffect } from 'react';
import HeaderV3 from '../../components/HeaderV3/headerV3.component';
import NewsSection from '../../components/NewsSection/newssection.component';
import OrbixContact from '../../components/ContactSection/contact.component';
import FooterSection from '../../components/FooterSection/footersection.component';

import { Fragment } from "react";
function News() {
  useLayoutEffect(() => {
    document.body.style.backgroundColor = '#131022';
    return () => { document.body.style.backgroundColor = ''; };
  }, []);
  return (
    <Fragment>
    {/* main */}
    <main className="page-wrapper dark-mode">
    {/* Header  */}
    <HeaderV3 />

    {/* Hero  */}
   

    {/* Partners Section  */}
    <NewsSection/>

    {/* Contact -1 */}
    <OrbixContact/>

    <FooterSection />
    </main>

    </Fragment>
  )
}

export default News